import { Pagination as SharedPagination } from 'shared/page/Pagination';
import { Filters, ResultDataStats } from '@/domain';

type PaginationProps = {
    stats: ResultDataStats;
    onFilterChanged: (filters: Filters) => void;
};

export const Pagination = ({ stats, onFilterChanged }: PaginationProps) => {
    const verifyPageNumber = (page: number): number => {
        if (page < 1 || !stats.totalPages) {
            return 1;
        } else if (page > +stats.totalPages) {
            return +stats.totalPages;
        } else {
            return page;
        }
    };

    const handleChange = (page: number): void => {
        page = verifyPageNumber(page);
        onFilterChanged({ page });
        if (document.activeElement) {
            // @ts-expect-error
            document.activeElement.blur();
        }
    };

    const currentPage = stats.currentPage ? stats.currentPage : 1;
    const totalPages = stats.totalPages ? stats.totalPages : 1;

    if (+totalPages < 2) {
        return <div data-testid="emptyPage" />;
    }
    return <SharedPagination currentPage={+currentPage} totalPages={+totalPages} onChange={handleChange} />;
};
